import { Dropdown, Select } from '@easyv/react-components';
import * as React from 'react';
import { deepClone, isNil, RuntimeComponent, RuntimeScene } from '@easytwin/runtime';
import { Tree, TreeDataProps } from './Tree';

export type EntitySelectType = {
  id: string;
  path?: string;
};

export type FilterFunction = (entity: RuntimeComponent) => boolean;

interface EntitySelectProps {
  scene: RuntimeScene;
  disabled?: boolean;
  showSearch?: boolean;
  placeHolder?: string;
  value: EntitySelectType;
  filter?: string[] | FilterFunction;
  onBlur: (value: EntitySelectType) => void;
}

export function EntitySelect(props: EntitySelectProps) {
  const { onBlur, scene, placeHolder, filter, value, disabled } = props;

  const [internalValue, setInternalValue] = React.useState<EntitySelectType>();
  const [treeData, setTreeData] = React.useState<TreeDataProps[]>([]);
  React.useEffect(() => {
    if (!scene.rootComponent?.children) return;
    setTreeData(getSelectItemsData());
    setInternalValue(value);
  }, [value]);
  const [inputValue, setInputValue] = React.useState<{ key: string; title: string }>();
  const [popupVisible, setPopupVisible] = React.useState(false);

  //获取世界大纲列表
  const getSelectItemsData = () => {
    const children = scene.rootComponent?.shownChildren.filter((item) => {
      if (filter === undefined) return true;
      const ok = typeof filter === 'function' ? filter(item) : filter.includes(item.type);
      return ok;
    });
    const getChildrenModel = (data: any[], id?: string) => {
      return data.map((node) => {
        const newNode: TreeDataProps = {
          key: '',
          id: id ? id : node.id,
          path: node.getSelectObject().userData.path ? node.getSelectObject().userData.path : '',
          title: node.name,
          collapsed: true,
          children: [],
          type: '',
        };
        if (node.shownChildren) {
          newNode.children = getChildrenModel(
            node.shownChildren.filter(
              (item: any) => item.type === 'Model' || item.type === 'EngineGroup',
            ),
            id || node.type === 'EngineGroup' ? id : node.id,
          );
        }
        newNode.key = newNode.id + newNode.path;
        newNode.type = node.type;
        return newNode;
      });
    };
    if (children) return getChildrenModel(children);
    else return [];
  };

  React.useEffect(() => {
    if (isNil(internalValue)) {
      setInputValue(undefined);
      return;
    }
    const key = internalValue.id + internalValue.path;
    const treeNode = findComp(key, treeData);
    if (treeNode) {
      setInputValue({
        key: treeNode.key,
        title: treeNode.title,
      });
    } else {
      setInputValue({ key, title: '已失效' });
    }
  }, [treeData]);
  React.useEffect(() => {}, [inputValue]);

  const findComp = (value: string, data: TreeDataProps[]) => {
    let result: TreeDataProps | undefined;
    data.forEach((item) => {
      if (item.key === value) {
        result = item;
      } else if (item.children) {
        const treeNode = findComp(value, item.children);
        if (treeNode) result = treeNode;
      }
    });
    return result;
  };

  const handleUpdateState = (value: TreeDataProps) => {
    console.log(value, treeData);
    if (isNil(treeData)) return;
    const selectedItem = findComp(value.key, treeData);
    if (isNil(selectedItem)) return;

    onBlur(selectedItem);
    setPopupVisible(false);
  };

  const handleCollapsed = (value: TreeDataProps) => {
    console.log('collapsed', value);
    const newData = deepClone(treeData);
    const collapsed = (data: TreeDataProps[]) => {
      for (const item of data) {
        if (item.key === value.key) {
          item.collapsed = !value.collapsed;
          return;
        }
        collapsed(item.children);
      }
    };
    collapsed(newData);
    console.log('newData::::', newData);
    setTreeData(newData);
  };

  const dropList = (
    <div
      style={{ width: '208px', maxHeight: '168px' }}
      className='flex flex-col bg-bgColor232324 border border-solid border-borderColorBase rounded  shadow-shadowlg'
    >
      <div className='flex-1 overflow-y-auto overflow-x-hidden no-scroll-container entityTree relative min-h-0'>
        <Tree
          dataSource={treeData}
          depth={0}
          selectedKey={inputValue?.key}
          setCollapsed={handleCollapsed}
          onSelect={handleUpdateState}
        />
      </div>
    </div>
  );

  return (
    <Dropdown
      disabled={disabled}
      droplist={dropList}
      popupVisible={popupVisible}
      position='bottom'
      trigger='click'
      onVisibleChange={(visible) => {
        setPopupVisible(visible);
      }}
    >
      <Select
        disabled={disabled}
        placeholder={placeHolder}
        value={inputValue?.title}
        notFoundContent={null}
        size='small'
      />
    </Dropdown>
  );
}
